import gql from 'graphql-tag';
export const loginMutation = gql `
  mutation login($record: LoginRecord!) {
    login(record: $record) {
      accessToken
    }
  }
`;
//# sourceMappingURL=login.js.map